interface IQueryStringVars {
    [key: string]: string;
}

export function getQSVar(name: string) {
    if (!window.location.search) return;

    const queryArray = window.location.search
        .replace('?', '')
        .split(/&(?=(\w)*=)/g);

    const qsVars = queryArray.reduce((acc: IQueryStringVars, val) => {
        const splittedVal = val.split('=');

        if (!splittedVal[1]) return acc;

        acc[splittedVal[0]] = splittedVal[1];

        return acc;
    }, {});

    if (!qsVars[name]) return;

    return decodeURIComponent(qsVars[name]);
}
